import React from 'react';
import ReactTable from 'react-table';
import selectTableHOC from 'react-table/lib/hoc/selectTable';
import _ from 'lodash';
import { connect } from 'react-redux';

import {AnalysisType, AnalysisTypeMainVATCodeOnly} from '../../utils/enums';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'

import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
const FORM_NAME = 'EXISTING_ANALYSIS_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const SelectTable = selectTableHOC(ReactTable);

class ExistingAnalysis extends React.Component {

    constructor(props) {
        super(props);        
        this.toggleSelection = this.toggleSelection.bind(this);
        this.toggleAll= this.toggleAll.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.state = {
            data: props.data,
            selection: new Set(),
            selectAll: false,
            selectType: "checkbox"
        };
    }

    toggleSelection(key, shift, row){
        log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
        log.clearSuccessMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_SUCCESS);
        log.clearAllDictionaryErrors();
        /*
          Implementation of how to manage the selection state is up to the developer.
          This implementation uses an array stored in the component state.
          Other implementations could use object keys, a Javascript Set, or Redux... etc.
        */
        // start off with the existing state
        let selection = new Set(this.state.selection);
        // check to see if the key exists
        if (selection.has(key)) {
          // it does exist so we will remove it using destructing
          selection.delete(key);
        } else {
          // it does not exist so add it
          selection.add(key);
        }
        // update the state
        this.setState({ selection: selection });
        this.props.onSelectionChange(selection, this.state.data);
      }
    
    toggleAll() {
        const selectAll = this.state.selectAll ? false : true;
        const selection = new Set();
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.viewTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;          
            // we just push all the IDs onto the selection array
            currentRecords.forEach(item => {
                if (item._original) {
                    selection.add(item._original.vatCode);
                }
            });
        }        
        this.setState({ selectAll: selectAll, selection: selection });
        this.props.onSelectionChange(selection, this.state.data);
    }
    
    isSelected(key) {
        return this.state.selection.has(key) || this.state.selection.has(`select-${key}`);
    }

    viewDetailsAndFilterClickHandler() {
        log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
        log.clearSuccessMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_SUCCESS);
        log.clearAllDictionaryErrors();
    }

    defaultSelectInputComponent() {
        return (type) => {
            return (
                <fieldset className="SelectTable">
                    <input
                        className='mt5 checkbox'
                        type={'checkbox'} 
                        checked={type.checked} 
                        onClick={(e)=>{
                          const { shiftKey } = e;
                          e.stopPropagation();
                          type.onClick(type.id, shiftKey, type.row);
                        }} 
                        onChange={()=>{}}  
                    />
                    <label className="mt5 checkbox"></label>
                </fieldset>
            )
        }
    }

    render() {
        log.debug('render(): ', this.props);
        const data = this.state.data || [];
        let columns = [
            {
                Header: <LanguageStringResolver string="analysisReportField_VATCode" />,
                accessor: 'vatCode',
                filterable:true,
            }, {
                Header: <LanguageStringResolver string="analysisReportField_GenericVATCode"/>,
                accessor: 'genericVATCode',
                filterable:true,
            }, {
                Header: <LanguageStringResolver string="analysisReportField_TaxableBasis"/>,
                accessor: 'taxableBasis',
                filterable:true,
                headerClassName: withFullStoryExclude(),
                className: withFullStoryExclude(),
            }, {
                Header: <LanguageStringResolver string="analysisReportField_VAT"/>,
                accessor: 'vat',
                filterable:true,
                headerClassName: withFullStoryExclude(),
                className: withFullStoryExclude(),
            }, {
                Header: <LanguageStringResolver string="analysisReportField_VATReversed"/>,
                accessor: 'vatReversed',
                filterable:true,
                headerClassName: withFullStoryExclude(),
                className: withFullStoryExclude(),
            }, {
                Header: <LanguageStringResolver string="analysisReportField_Currency"/>,
                accessor: 'currency',
                filterable:true,
            }, {
                Header: <LanguageStringResolver string="analysisReportField_Company"/>,
                accessor: 'company',
                filterable:true,
            }, {
                Header: <LanguageStringResolver string="analysisReportField_Transaction"/>,
                accessor: 'transaction',
                filterable:true,
            }, {
                Header: <LanguageStringResolver string="analysisReportField_OwnComments"/>,
                accessor: 'ownComments',
                filterable:true,
            }, {
                Header: <LanguageStringResolver string="analysisReportField_BookingInformation"/>,
                accessor: 'bookingInformation',
                filterable:true,
            }, {
                Header: <LanguageStringResolver string="analysisReportField_Amount"/>,
                accessor: 'amount',
                filterable:true,
                headerClassName: withFullStoryExclude(),
                className: withFullStoryExclude(),
            }, {
                Header: <LanguageStringResolver string="analysisReportField_Actions"/>,
                accessor: '',
                filterable:false,
                Cell: ({original}) => {
                  return (
                    <a className="tertiary bold" onClick={this.viewDetailsAndFilterClickHandler}>
                      <LanguageStringResolver string="analysisReportField_Details"/>
                    </a>
                  );
                },
            }]
        if (this.props.enableCompanyNameInVatCodeReport) {
          columns.forEach((column, index) => {
            if (column.accessor === 'company') {
              column.Header = <LanguageStringResolver string="analysisReportField_Company_feature"/>;
              column.sortable = true;
              
              let companyNameColumn = {
                 Header: <LanguageStringResolver string="analysisReportField_CompanyName"/>,
                 accessor: 'companyName',
                 filterable: true,
                 sortable: true
              };
              // Insert the new column right after the company column
              columns.splice(index + 1, 0, companyNameColumn);
            }
          });
        }

        const tableOptions = this.props.tableOptions || {};
        const checkboxProps = {
            selectAll: this.state.selectAll,
            isSelected: this.isSelected,
            toggleAll: this.toggleAll,
            toggleSelection: this.toggleSelection,
            selectType: "checkbox"
        }

        const NoDataComponent = props => (
            <NoData
              noDataText="existingAnalysis_NoData"
              {...props}
            />
          )

        return (
            <SelectTable
                defaultPageSize={20}
                minRows={0}
                maxRows={0}
                ref={(r) => this.viewTable = r}
                data={data}
                columns={columns}
                keyField="vatCode"
                defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value)}
                {...checkboxProps}
                {...tableOptions}
                NoDataComponent={NoDataComponent}
                PaginationComponent={Pagination}
                showPagination={data.length === 0 ? false : true}
                onFilteredChange={this.viewDetailsAndFilterClickHandler}
                SelectInputComponent={this.defaultSelectInputComponent()}
                SelectAllInputComponent={this.defaultSelectInputComponent()}
            />
        );
    }

    componentDidUpdate(prevProps) {
        if(this.props.data !== prevProps.data) {
            this.setState( {
                data: this.props.data,
                selection: new Set(),
                selectAll: false,
            });
        }
        if(this.props.resetSelection && (this.props.resetSelection !== prevProps.resetSelection)) {
            this.setState({
                selection: new Set(),
                selectAll: false
            });
        }
    }
}


ExistingAnalysis.defaultProps = {
    data: [],
    reportFields: [],
    tableOptions: {},
    onSelectionChange: () => {}
};

function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        enableCompanyNameInVatCodeReport: state.featureFlag?.data?.EnableCompanyNameInVatCodeReport
    };
}

export default connect(mapStateToProps)(ExistingAnalysis);